import Configs from './config';
import * as Enums from './enums';
import Paths from './paths';
import * as Regex from './regex';
import Routes from './routes';
import * as Value from './value';

export const DatePattern = {
  DATE: 'YYYY-MM-DD',
  DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
  TIMESTAMP: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
};

export { Configs, Enums, Paths, Routes, Regex, Value };
